import styled, { css } from 'styled-components'
import { HELPER_CLASS } from '../SortableList/consts'
import { mediaQueries } from '../../providers/MediaQueryProvider'

export const Container = styled.div`
  margin: var(--space-n400);
`

export const ItemContainer = styled.div`
  position: relative;
`

export const Item = styled.div`
  position: relative;
`

export const Placeholder = styled.div`
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--bg-secondary);
`

export const ToolbarContainer = styled.div`
  display: flex;
  position: absolute;
  top: 29px;
  right: var(--space-400);

  ${mediaQueries.tablet} {
    display: none;
    top: 37px;
  }
`

type ElementProps = {
  isDragged: boolean
}

export const Element = styled.div<ElementProps>`
  position: relative;
  background-color: var(--bg-primary);
  margin-bottom: var(--space-400);
  padding: var(--space-200) var(--space-400);

  ${({ isDragged }) =>
    !isDragged &&
    css`
      &:hover ${ToolbarContainer} {
        display: flex;
      }
    `}

  &.${HELPER_CLASS} {
    pointer-events: auto !important;
    z-index: 999;
    box-shadow: 0px var(--space-400) var(--space-1000) var(--color-black-alpha-1000);
  }

  &.${HELPER_CLASS} ${ToolbarContainer} {
    display: flex;
  }

  ${mediaQueries.tablet} {
    padding: var(--space-400);
  }
`

export const Handle = styled.div`
  margin-left: var(--space-400);

  color: var(--text-secondary);
  cursor: pointer;

  &:hover {
    color: var(--text-primary);
  }
`

export const DragHandle = styled(Handle)`
  cursor: move;
  cursor: grab;

  .${HELPER_CLASS} & {
    cursor: grabbing;
  }
`
